export const toggleGetter = state => {
  return state.toggleState
}

export const recordGetter = state => {
  return state.recordState
}
